import { DateTime } from 'luxon';
import type { Bicycle } from '../types';
import type { FilterSelection } from './getBicycleFilterValues';
import { filterToBicycleFieldMap } from './getBicycleFilterValues';

const bicycleFilterFn =
    (name: keyof FilterSelection, values: string[]) => (vehicle: Bicycle) => {
        const value = vehicle[filterToBicycleFieldMap[name]];

        if (name === 'modelYear') {
            const { manufacturingStartYear, manufacturingEndYear } = vehicle;

            if (!manufacturingStartYear && !manufacturingEndYear) {
                return false;
            }

            return values.some(
                filterValue =>
                    Number(filterValue) >= (manufacturingStartYear ?? 0) &&
                    Number(filterValue) <=
                        (manufacturingEndYear ?? DateTime.utc().year)
            );
        }

        return values.includes(`${value}`);
    };

const filterBicycles = (
    vehicles: Bicycle[],
    filters: FilterSelection
): [boolean, Bicycle[]] => {
    let filteredVehicles = vehicles;
    let areFiltersActive = false;

    for (const [name, values] of Object.entries(filters) as [
        keyof FilterSelection,
        string[],
    ][]) {
        if (values.length > 0) {
            areFiltersActive = true;
            filteredVehicles = filteredVehicles.filter(
                bicycleFilterFn(name, values)
            );
        }
    }

    return [areFiltersActive, filteredVehicles];
};

export default filterBicycles;
